import { lazy } from 'react';

export { CredentialHealthBrokenCredentials } from '../pages/CredentialHealthBrokenCredentials';
export { CredentialHealthDashboard } from '../pages/CredentialHealthDashboard';
export { CredentialHealthRemediation } from '../pages/CredentialHealthRemediation';

export const CredentialHealthScanDetail = lazy(() =>
  import('../pages/CredentialHealthScanDetail').then((module) => ({
    default: module.CredentialHealthScanDetail,
  }))
);
